import React, { useEffect, useContext, useState, Suspense } from 'react'
import { Route, Routes, useLocation } from 'react-router-dom';
import route from "./helper/route"
import 'bootstrap/dist/css/bootstrap.min.css';
import 'swiper/css';
import "./assets/css/App.css"
import Button from 'react-bootstrap/Button';
import { MdOutlineKeyboardArrowUp } from 'react-icons/md'
import Header from './layout/Header';
import { CartContext } from './context/CartContext';
import LoaderMain from './components/LoaderMain';
import CartDrawer from './page/CartDrawer';
import InstallApp from './components/InstallApp';
import Footer from './layout/Footer';
import BottomNav from './components/BottomNav';

const ScrollToTop = () => {

  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

const ClientPanel = () => {
  const [active, setActive] = useState(window.location.pathname);
  const { drawer, mainloder, mainstopAnimation, mainstartAnimation, mainplayer } = useContext(CartContext);

  const showHeaderAndFooter = window.location.pathname !== "/delete-account";
  const hideFooter = window.location.pathname === "/";


  useEffect(() => {
    if (window.location.pathname !== "/login" && window.location.pathname !== "/register") {
      localStorage.setItem('lastVisitedPath', window.location.pathname);
    }
  }, [window.location.pathname]);


  // user devise 
  function getMobileOperatingSystem() {
    const userAgent = navigator.userAgent || navigator.vendor;
    // Apple devices (iPod, iPhone and iPad)
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    // Android devices
    else if (/android/i.test(userAgent)) {
      return "Android";
    }

    // If it's not an iPhone or Android we will assume it's "desktop"
    return "desktop";
  }


  // COMMENTED OUT - Was causing random Apple Store redirects
  // ios user redirect to appstore - disabled for product pages and shop to allow scrolling
  // useEffect(() => {
  //   // Only redirect on non-product pages and non-shop pages to allow scrolling
  //   if (!window.location.pathname.startsWith("/product-details/") && 
  //       !window.location.pathname.startsWith("/home") && 
  //       getMobileOperatingSystem() == "iOS") {
  //     // Add a small delay to prevent immediate redirect
  //     const timer = setTimeout(() => {
  //       window.open("https://apps.apple.com/us/app/clubmall/id6444752184");
  //     }, 2000); // 2 second delay
  //     
  //     return () => clearTimeout(timer);
  //   }
  // }, [window.location.pathname]);


  function getPathName() {
    const path = window.location.pathname;
    const pathParts = path.split("/");
    const firstPartOfPath = pathParts[1];

    if (!firstPartOfPath || firstPartOfPath === '') {
      return "For you";
    } else if (firstPartOfPath.toLowerCase() === 'selling') {
      return "Hot selling";
    } else {
      return firstPartOfPath.charAt(0).toUpperCase() + firstPartOfPath.slice(1);
    }
  }

  useEffect(() => {
    document.title = `${getPathName()} | Clubmall`;
  }, [window.location.pathname]);


  // Keep page locking deterministic when either full-screen overlay is open.
  useEffect(() => {
    const shouldLockPage = mainloder || drawer;
    document.body.style.overflow = shouldLockPage ? 'hidden' : '';
    document.documentElement.style.overflow = shouldLockPage ? 'hidden' : '';

    return () => {
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    };
  }, [mainloder, drawer]);


  return (
    <div>
      {window.location.pathname !== '/' && window.location.pathname !== '/delete-account'   && (
        <>   
        <div className="cart-top-main">
          <Button
            className="btn-scroll-top mt-3"
            onClick={() => window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })}
          >
            <MdOutlineKeyboardArrowUp />
          </Button>
        </div>
        </>
      )}
      {mainloder && (
        <div className="loader-main">
          <LoaderMain startAnimationMain={mainstartAnimation} stopAnimationMain={mainstopAnimation} player={mainplayer} />
        </div>
      )}

      <CartDrawer />
      <ScrollToTop />
      <InstallApp />

      <div className="page-layout">
        {showHeaderAndFooter && <Header active={active} setActive={setActive} />}
        <div className="mar-cos">
          <Suspense fallback={<div></div>}>
            <Routes>
              {route.map((route, index) => (
                <Route key={index} exact path={route.path} element={route.element} />
              ))}
            </Routes>
          </Suspense>
          <BottomNav />
        </div>
        {showHeaderAndFooter && !hideFooter && <Footer />}
      </div>

    </div>
  );
};

export default ClientPanel;














